function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0d4520",
      fillOpacity: 1
    },
    d: "M 0 6.710938 L 0 6.507812 C 0 4.050781 1.777344 1.953125 4.199219 1.550781 C 5.769531 1.285156 7.433594 1.804688 8.578125 2.953125 L 9 3.375 L 9.390625 2.953125 C 10.566406 1.804688 12.199219 1.285156 13.800781 1.550781 C 16.222656 1.953125 18 4.050781 18 6.507812 L 18 6.710938 C 18 8.171875 17.394531 9.566406 16.328125 10.5625 L 9.972656 16.492188 C 9.707031 16.738281 9.363281 16.875 9 16.875 C 8.636719 16.875 8.292969 16.738281 8.027344 16.492188 L 1.671875 10.5625 C 0.605469 9.566406 0 8.171875 0 6.710938 Z M 0 6.710938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.480d383a8cac3ac1faf7863faa4e4b66.svg";
export { ForwardRef as ReactComponent };